'use client'

import { SystemMessage } from '@/app/_shared/components/SystemMessage'

interface NotFoundProps {
	goBackHref?: string
	reset?: () => void
}
export const SomethingWentWrong = ({ goBackHref, reset }: NotFoundProps) => {
	return <SystemMessage message='Something went wrong' goBackHref={goBackHref} reset={reset} />
}
